import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.9.586c-.1-.195-.3-.39-.5-.488C19.3 0 19.1 0 19 0h-6c-.6 0-1 .391-1 .978 0 .586.4.978 1 .978h3.6l-5.3 5.18a.93.93 0 0 0 0 1.37c.2.195.5.293.7.293s.5-.098.7-.294L18 3.326v3.518c0 .587.4.978 1 .978s1-.391 1-.978V.978c0-.098 0-.294-.1-.392M7.3 11.048 2 16.228v-3.52c0-.586-.4-.977-1-.977s-1 .391-1 .978v5.865c0 .098 0 .294.1.392.1.195.3.39.5.488.1.098.3.098.4.098h6c.6 0 1-.391 1-.977 0-.587-.4-.978-1-.978H3.4l5.3-5.181a.93.93 0 0 0 0-1.369.98.98 0 0 0-1.4.001"
    }, null, -1)
  ]))]))
}
export default { render: render }